import React, { Dispatch, SetStateAction } from 'react';
import { BestValueContainer } from './components/BestValueContainer';
import { OneMillionContainer } from './components/OneMillionContainer';
import styles from './UpgradeRedesign.module.scss';

interface ICouponProps {
  handleApplyCoupon: () => void;
  handleRemoveCoupon: () => void;
  couponError: { message: string };
  couponsApplied: { [key: string]: string }[];
  couponCode: string;
  setCouponError?: Dispatch<SetStateAction<{ message: string }>>;
}

interface BaseUpgradePageProps {
  onSubmitSubscription: () => void;
  getCouponContentKey: (key: string, defaultValue: string) => string;
  hCaptcha: any;
  couponProps: ICouponProps;
}

const UpgradeRedesign = (props: BaseUpgradePageProps) => {
  return (
    <main className={styles.upgradeWrapper}>
      <div className={styles.upgradeContainer}>
        <BestValueContainer />
        <OneMillionContainer />
      </div>
    </main>
  );
};

export { UpgradeRedesign };
export type { BaseUpgradePageProps, ICouponProps };
